export default {
    "string" :"dbString",
    "int" :"dbInt",
    "float" :"dbFloat",
    "double" :"dbDouble",
    "text" :"dbText ",
    "boolean" :"dbBoolean ",
    "datetime" :"dbDatetime ",
    "timestamp"  :"dbTimestamp "
}